module.exports = __webpack_public_path__ + "static/media/mybb-header.9ff1c1f3.svg";